import React from 'react';
import useInactivityTimer from 'lib/hooks/useInactivityTimer';
import InactivityWarningDialog from 'components/ui/InactivityWarningDialog';

const MINUTES_UNTIL_LOGOUT = 1;

/**
 * InactivityMonitor component
 *
 * Monitors user activity and displays a warning dialog 1 minute before
 * automatic logout due to inactivity (30 minutes).
 *
 * This component should be placed at the root level of authenticated routes
 * to ensure it's active whenever the user is logged in.
 */
const InactivityMonitor: React.FC = () => {
  const { showWarning, dismissWarning } = useInactivityTimer();

  return (
    <InactivityWarningDialog
      open={showWarning}
      minutesUntilLogout={MINUTES_UNTIL_LOGOUT}
      onStayLoggedIn={dismissWarning}
    />
  );
};

export default InactivityMonitor;
